import styled from "styled-components"
import Graphic from "../../assets/images/login_graphic.svg"
import Pig from "../../assets/images/login_pig.png"
import { COLORS, SCREEN_SIZES } from "../../constants"
import { Row, Col } from "reactstrap"
import { CustomInput, CustomButton } from "../../components"
import { Link } from "react-router-dom"
import { useHistory } from "react-router-dom";
import { useState } from "react"
import { validateEmail, validatePassword, checkPasswordMatch } from "../../features"
import { setLoggedUser, setUserRole } from "../../redux/actions"
import { useDispatch } from "react-redux"
import { useQuery } from "../../features"

import ReactLoading from "react-loading"
import { useLocation } from 'react-router-dom';
import ReactModal from 'react-modal';
import axios from 'axios';

const StyledCol = styled(Col)`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const StyledRow = styled(Row)`
    padding: 50px;
    @media only screen and (max-width: ${SCREEN_SIZES.lg}) {
        padding: 20px 0;
    }
`;
const StyledHeader = styled.h5`
  color: ${COLORS.text_green};
`;
const StyledLabel = styled.div`
  text-align: start;
  color: ${COLORS.text_grey};
`;
const StyledPig = styled.img`
   width: 250px;
   @media only screen and (max-width: ${SCREEN_SIZES.lg}) {
       width: 200px;
    }
`;
const StyledSideGreen = styled.img`
  position: absolute;
  height: 70%;
  left: 0;
  bottom: 0;
  z-index: 0;

  @media only screen and (max-width: ${SCREEN_SIZES.lg}) {
      display: none;
    }
`;
const StyledForm = styled.form`
    width: 80%;
    @media only screen and (max-width: ${SCREEN_SIZES.sm}) {
      width: 100%;
      padding: 20px;
    }
`;
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: 10,
        border: 0
    },
    overlay: {
        backgroundColor: "rgba(0,0,0, 0.5)"
    }
};
export function ResetPassword(props) {
    const api = process.env.REACT_APP_API_URL;
    const { state } = useLocation();
    // const query = useQuery();



    const [loading, setLoading] = useState(false);
    const [password, setPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newPasswordRepeat, setNewPasswordRepeat] = useState('');
    const [emailOrID, setEmailOrID] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [serverError, setServerError] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [passwordToken, setPasswordToken] = useState('');
    const [success, setSuccess] = useState(false);

    const history = useHistory();
    const dispatch = useDispatch();


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        // const firstResponse = await axios.get(`${api}/pt/get_password_token/${state.email}`);
        const secondResponse = await axios.post(`${api}/pt/validate_password_token`, { token: props.token })


        if (secondResponse.data.status_code == 1) {

            if (validatePassword(newPassword)) {
                if (checkPasswordMatch(newPassword, newPasswordRepeat)) {

                    const response = await axios.post(`${api}/pt/reset_password`, { token: props.token, password: newPassword, password_confirmation: newPasswordRepeat });
                    const data = response.data;
                    setLoading(false)
                    if (data.status_code == -1) {

                        setServerError(data.message)
                        setModalOpen(true)
                    } else {
                        setSuccess(true)
                    }

                } else {
                    setLoading(false)
                    setPasswordError('Passwords do not match');
                }

            } else {
                setLoading(false)
                setPasswordError('Password should contain at least one uppercase, one lowercase letter and have more than 7 characters.')
            }
        } else {
            setLoading(false)
            alert('Token is not valid')
        }
    }
    return (
        <>
            <ReactModal ariaHideApp={false} isOpen={modalOpen} contentLabel="Error" role="dialog" style={customStyles} onRequestClose={() => setModalOpen(false)}>
                <div className="d-flex flex-column align-items-center">
                    <h5>Error</h5>
                    {serverError}
                    <CustomButton
                        style={{ width: 200, marginTop: 10 }}
                        color={COLORS.text_dark_green}
                        bgColor={COLORS.green}
                        hover={COLORS.text_green}
                        onClick={() => setModalOpen(false)}
                    >
                        Close
                </CustomButton>
                </div>
            </ReactModal>
            <StyledRow className="m-0 h-100 d-flex justify-content-center">
                <StyledSideGreen src={Graphic} />

                <StyledCol lg={8}>
                    {success ? <div><StyledHeader>Password Reset</StyledHeader><div>Your password has been successfully reset. Press button below to login to the app.</div>
                        <Link to="/">
                            <CustomButton
                                style={{ width: 200, marginTop: 10 }}
                                color={COLORS.text_dark_green}
                                bgColor={COLORS.green}
                                hover={COLORS.text_green}
                                onClick={() => setModalOpen(false)}
                            >
                                Log In
                    </CustomButton>
                        </Link>
                    </div> :
                        <StyledForm>
                            <StyledHeader>Password Reset</StyledHeader>


                            <StyledLabel className="mt-3">New Password</StyledLabel>
                            <CustomInput name="password" type="password" className="w-100" value={newPassword} onChange={(event) => {
                                setNewPassword(event.target.value)
                                setPasswordError('')
                            }} />
                            <StyledLabel className="mt-3">New Password Repeat</StyledLabel>
                            <CustomInput name="password" type="password" className="w-100" value={newPasswordRepeat} onChange={(event) => {
                                setNewPasswordRepeat(event.target.value)
                                setPasswordError('')
                            }} />
                            <div className="text-left" style={{ fontSize: 14, color: "red" }}>{passwordError}</div>
                            <CustomButton
                                className="mt-4 w-100"
                                color={COLORS.text_dark_green}
                                bgColor={COLORS.green}
                                hover={COLORS.text_green}
                                disabled={loading}
                                onClick={handleSubmit}
                            >
                                {loading ? <><ReactLoading type="spin" color={COLORS.text_dark_green} height={20} width={20} className="d-inline-block" /><span className="ml-2">Loading...</span></> : 'Submit'}
                            </CustomButton>
                            <div className="d-flex flex-row justify-content-between mt-4">
                                <span style={{ color: COLORS.text_grey }}>Remembered Password?</span>
                                <Link to="/" className="hover-text-green">Log In</Link>
                            </div>
                        </StyledForm>
                    }

                </StyledCol>
            </StyledRow>
        </>
    );
}